module.exports = __webpack_public_path__ + "img/Flag_of_Lesotho.162a0929.svg";